var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('em',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.name),expression:"name"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }